import { render, staticRenderFns } from "./DomainEditor.vue?vue&type=template&id=fb4c96b0&scoped=true"
import script from "./DomainEditor.vue?vue&type=script&lang=js"
export * from "./DomainEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4c96b0",
  null
  
)

export default component.exports